export default {
  primary: "#00539F",
  secondary: "#00B5E4",
  accent: "#FE5A32",
  error: "#FF5252",
  info: "#A4A7AB",
  success: "#4CAF50",
  warning: "#FFC107",
};
